"use client";

import { motion } from "framer-motion";
import { TrendingUp, ChevronRight } from "lucide-react";
import { fadeUp, Section, img } from "./utils";

export function Industries() {
  const items = [
    {
      img: img.realEstate,
      title: "Real Estate",
      href: "/solutions/real-estate",
      desc: "Your AI agents work the deal from first inquiry to signed contract — qualifying buyers, booking viewings, sending documents, and following up across every channel, even at 2 AM.",
      result: "Gulf Realty closed 34 deals in the first month.",
    },
    {
      img: img.carFleet,
      title: "Car Rental & Fleet",
      href: "/solutions/car-rental",
      desc: "Your AI fleet coordinator manages bookings, schedules maintenance, and coordinates across locations — so your human team focuses on growing the business.",
      result: "DriveHub cut time-to-action from 4 hours to 3 minutes.",
    },
    {
      img: img.facility,
      title: "Facility Management",
      href: "/solutions/facility-management",
      desc: "Triage service requests, dispatch teams, and keep tenants informed — so nothing falls through the cracks and tenants always know what's happening.",
      result: "Tenant satisfaction up 40% in 90 days.",
    },
  ];

  return (
    <Section id="industries" className="px-6 py-28 max-w-7xl mx-auto">
      <motion.div variants={fadeUp} className="text-center mb-14">
        <p className="text-sm font-medium text-coral-400 mb-3 uppercase tracking-wider">
          Built for your industry
        </p>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-content">
          For businesses that run the real world.
        </h2>
        <p className="mt-3 text-content-muted max-w-lg mx-auto text-base">
          Not SaaS companies. Not tech startups. The messy, coordination-heavy
          industries that still run on phone calls and spreadsheets.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {items.map((item, i) => (
          <motion.div
            key={i}
            variants={fadeUp}
            custom={i}
            className="group relative rounded-2xl overflow-hidden border border-surface-border hover:border-surface-hover transition-all duration-300 hover:-translate-y-1 flex flex-col"
          >
            <div className="h-48 relative overflow-hidden shrink-0">
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/60 to-transparent" />
            </div>
            <div className="p-6 bg-surface/50 flex flex-col flex-1">
              <h3 className="text-lg font-semibold text-content mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-content-muted leading-relaxed flex-1">
                {item.desc}
              </p>
              <p className="mt-3 text-xs font-medium text-ok flex items-center gap-1.5">
                <TrendingUp size={12} />
                {item.result}
              </p>
              <a
                href={item.href}
                className="inline-flex items-center gap-1 mt-4 text-sm text-coral-400 hover:text-coral-300 transition-colors"
              >
                Learn more <ChevronRight size={14} />
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
